// cryptoSignService.js — переписано под CDN cadesplugin_api.js (WebExtension/WebSocket)
// НЕ использует NPAPI, НЕ использует pluginObject, НЕ использует waitPlugin
// Работает с window.cadesplugin (универсальный режим)

async function getPlugin() {
  if (!window.cadesplugin) {
    throw new Error("cadesplugin не найден. Убедись, что CDN скрипт подключён в index.html")
  }
  await window.cadesplugin
  return window.cadesplugin
}
// ----------------------------------------------------------------------
// Получение сертификатов
// ----------------------------------------------------------------------
export async function getCertificates() {
   if (window.cadesplugin) {
      await window.cadesplugin
      const store = await window.cadesplugin.CreateObjectAsync('CAdESCOM.Store');
      await store.Open();
      const certs = await store.Certificates;
      const count = await certs.Count;
      const list = []
      for (let i = 1; i <= count; i++) {
        const cert = await certs.Item(i)
        const thumbprint = await cert.Thumbprint
        const subject = await cert.SubjectName
        const validFrom = await cert.ValidFromDate
        const validTo = await cert.ValidToDate
        list.push({ index: i, thumbprint, subject, validFrom, validTo, cert })
      }

      await store.Close();
      return list
    }
  }

// ----------------------------------------------------------------------
// Подпись файла
// ----------------------------------------------------------------------
export async function signFileWithCert(base64, certObj, fileName = 'signature.p7s') {
  if (!base64) throw new Error("Файл не выбран")
  if (!certObj?.cert) throw new Error("Сертификат не выбран")

  await getPlugin()

  const hasher = await window.cadesplugin.CreateObjectAsync("CAdESCOM.HashedData")
  await hasher.propset_Algorithm(
    window.cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_256
  )
  await hasher.Hash(base64)

  const signer = await window.cadesplugin.CreateObjectAsync("CAdESCOM.CPSigner")
  await signer.propset_Certificate(certObj.cert)
  await signer.propset_CheckCertificate(false)

  const signedData = await window.cadesplugin.CreateObjectAsync("CAdESCOM.CadesSignedData")
  await signedData.propset_ContentEncoding(
    window.cadesplugin.CADESCOM_BASE64_TO_BINARY
  )
  await signedData.propset_Content(base64)

  const signatureBase64 = await signedData.SignCades(
    signer,
    window.cadesplugin.CADESCOM_CADES_BES,
    true
  )
  console.log(fileName)

  // const raw = Uint8Array.from(atob(signatureBase64), c => c.charCodeAt(0))
  // const blob = new Blob([raw], { type: 'application/pkcs7-signature' })

  // const a = document.createElement('a')
  // a.href = URL.createObjectURL(blob)
  // a.download = fileName
  // a.click()
  // URL.revokeObjectURL(a.href)
  return signatureBase64
}


// ----------------------------------------------------------------------
// Универсальная функция подписи и отправки на сервер
// ----------------------------------------------------------------------
export async function signBase64File(base64, cert) {
  if (!base64) throw new Error('Нет данных для подписи')
  if (!cert) throw new Error('Сертификат не выбран')

  return await signFileWithCert(base64, cert, true)
}